import { useCallback, useEffect, useState } from 'react'

const RESEND_COOLDOWN_SECONDS = 60

type ResendCooldownResult = {
  resendSecondsLeft: number
  resetCooldown: () => void
  startResendCooldown: () => void
}

export function useResendCooldown(): ResendCooldownResult {
  const [resendSecondsLeft, setResendSecondsLeft] = useState(0)

  const startResendCooldown = useCallback(() => {
    setResendSecondsLeft(RESEND_COOLDOWN_SECONDS)
  }, [])

  const resetCooldown = useCallback(() => {
    setResendSecondsLeft(0)
  }, [])

  useEffect(() => {
    if (resendSecondsLeft <= 0) return
    const timerId = setInterval(() => {
      setResendSecondsLeft((seconds) => (seconds > 0 ? seconds - 1 : 0))
    }, 1000)

    return () => clearInterval(timerId)
  }, [resendSecondsLeft])

  return { resendSecondsLeft, startResendCooldown, resetCooldown }
}
